/**
 * figma: ❖ Congrats screen hexagon badges (Activities & Challenges pt1)
 * One hexagon illustration per (type, module). React Native needs static
 * require() calls, hence the explicit map.
 */

export type CongratsBadgeKind = 'bell' | 'confettis' | 'flower' | 'medal';

type ModuleKey =
  | 'education'
  | 'energy_boost'
  | 'mood_boost'
  | 'self_care'
  | 'sleep_well'
  | 'social'
  | 'stress_anxiety';

const BADGES: Record<CongratsBadgeKind, Partial<Record<ModuleKey, number>>> = {
  bell: {
    education: require('../../assets/images/challenges/congrats/congrats_bell_education.png'),
    energy_boost: require('../../assets/images/challenges/congrats/congrats_bell_energy_boost.png'),
    mood_boost: require('../../assets/images/challenges/congrats/congrats_bell_mood_boost.png'),
    sleep_well: require('../../assets/images/challenges/congrats/congrats_bell_sleep_well.png'),
    social: require('../../assets/images/challenges/congrats/congrats_bell_social.png'),
    stress_anxiety: require('../../assets/images/challenges/congrats/congrats_bell_stress_anxiety.png'),
  },
  confettis: {
    education: require('../../assets/images/challenges/congrats/congrats_confettis_education.png'),
    energy_boost: require('../../assets/images/challenges/congrats/congrats_confettis_energy_boost.png'),
    mood_boost: require('../../assets/images/challenges/congrats/congrats_confettis_mood_boost.png'),
    self_care: require('../../assets/images/challenges/congrats/congrats_confettis_self_care.png'),
    sleep_well: require('../../assets/images/challenges/congrats/congrats_confettis_sleep_well.png'),
    social: require('../../assets/images/challenges/congrats/congrats_confettis_social.png'),
    stress_anxiety: require('../../assets/images/challenges/congrats/congrats_confettis_stress_anxiety.png'),
  },
  flower: {
    education: require('../../assets/images/challenges/congrats/congrats_flower_education.png'),
    energy_boost: require('../../assets/images/challenges/congrats/congrats_flower_energy_boost.png'),
    mood_boost: require('../../assets/images/challenges/congrats/congrats_flower_mood_boost.png'),
    self_care: require('../../assets/images/challenges/congrats/congrats_flower_self_care.png'),
    sleep_well: require('../../assets/images/challenges/congrats/congrats_flower_sleep_well.png'),
    social: require('../../assets/images/challenges/congrats/congrats_flower_social.png'),
    stress_anxiety: require('../../assets/images/challenges/congrats/congrats_flower_stress_anxiety.png'),
  },
  medal: {
    education: require('../../assets/images/challenges/congrats/congrats_medal_education.png'),
    energy_boost: require('../../assets/images/challenges/congrats/congrats_medal_energy_boost.png'),
    mood_boost: require('../../assets/images/challenges/congrats/congrats_medal_mood_boost.png'),
    self_care: require('../../assets/images/challenges/congrats/congrats_medal_self_care.png'),
    sleep_well: require('../../assets/images/challenges/congrats/congrats_medal_sleep_well.png'),
    social: require('../../assets/images/challenges/congrats/congrats_medal_social.png'),
    stress_anxiety: require('../../assets/images/challenges/congrats/congrats_medal_stress_anxiety.png'),
  },
};

/**
 * The activity design-system colors map onto the design's visual modules.
 * Keys are the enum NAMES (type-graphql serialises names, so the wire value
 * is always the uppercase form) — all 9 DesignSystemColors are covered.
 */
const MODULE_BY_DESIGN_COLOR: Record<string, ModuleKey> = {
  LAVENDER: 'mood_boost',
  VIOLET: 'mood_boost',
  VISTA_BLUE: 'sleep_well',
  TURQUOISE: 'stress_anxiety',
  TANGERINE: 'energy_boost',
  YELLOW: 'energy_boost',
  LIGHT_GREEN: 'self_care',
  ELECTRIC_BLUE: 'education',
  PINK: 'social',
};

export const congratsBadgeSource = (
  kind: CongratsBadgeKind,
  designSystemColor?: string | null,
): number => {
  const module = MODULE_BY_DESIGN_COLOR[designSystemColor || ''] || 'mood_boost';
  return BADGES[kind][module] || BADGES[kind].mood_boost as number;
};
